import http from '@gp/utils/httpTS';
import { InDevelopmentDataType } from '../types/services';

export const fetchInDevelopmentData = (params: {
  'select_id': string[],
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}): Promise<InDevelopmentDataType> => {
  return http.post('/api/v1/globalpedia_pc/studio_monthly_report/in_dev', params);
};

export const inDevelopmentDownLoad = (params: {
  'file_type': 1 | 2, // 1: csv 2: excal
  'select_id': string[],
  'order'?: 'asc' | 'desc',
  'order_metric'?: string,
}) => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/studio_monthly_report/in_dev/download',
    method: 'post',
    data: params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
